module.exports = __webpack_public_path__ + "static/media/dorp.30169fd3.png";